import { deleteRequest, getRequest, postRequest, putRequest } from "./ApiRequest";

// Stile della carta online per tipo di carta (bottone, categorie, sottocategorie, prodotto, copertina).
export const GetStylesAPI = () => getRequest("menucard/style");
export const SaveStyleAPI = (kind, groups) => putRequest(`menucard/style/${kind}`, groups);
export const ResetStyleAPI = (kind) => deleteRequest(`menucard/style/${kind}`);
export const UploadStyleImageAPI = (kind, file) => {
  const form = new FormData();
  form.append("image", file);
  return postRequest(`menucard/style/${kind}/image`, form);
};
export const DeleteStyleImageAPI = (kind) => deleteRequest(`menucard/style/${kind}/image`);

// Impostazioni di stampa del ristorante, separate per area (drinks | food).
export const GetPrintSettingsAPI = (area) => getRequest(`menucard/print-settings/${area}`);
export const SavePrintSettingsAPI = (area, settings) => putRequest(`menucard/print-settings/${area}`, settings);
